<template>
  <div class="page">
    <img  :src="pcImgSrc || mImgSrc" @click="handleClickToLink"/>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: "landing-page",
  data () {
    return {
      pcImgSrc: null, // pc 图
      mImgSrc: null, // 移动端 图
      link: 'https://mp.weixin.qq.com/s/bPyJPMIKS_6UIFSsaysiaA' // 跳转地址
    }
  },
  created () {
    this.displayTips();
    const { token } = this.$route.params
    this.getLandingPageDataFunc(token)
  },
  methods:{
    displayTips() {
      if (this.$route.query.pageSource === 'download') {
        this.$message.success('下载成功');
      }
    },
    handleClickToLink(){
      if(!this.link){
          return
      }
      window.open(this.link,"_blank")
    },
    async getLandingPageDataFunc (token) {
      try {
        let params = {
          token
        }
        let res = await api.account.getLandingPageData(params)
        if (res.code === 1000) {
          this.pcImgSrc = res.data.pc_img
          this.mImgSrc = res.data.img
          this.link = res.data.miniprogram_url
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page{
  width: 100vw;
  //height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  img {
    width: 100%;
    //height: 100%;
  }
}
</style>
